import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  TopSpendSuppliersQuery,
  TopSpendSuppliersRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const topSpendSuppliersQuery = graphql(`
  query topSpendSuppliers($request: TopSpendSuppliersRequest!) {
    topSpendSuppliers(TopSpendSuppliersRequest: $request) {
      totalResults
      results {
        supplierGuid
        supplierName
        totalValue
        transactionCount
      }
    }
  }
`);

/** One supplier's total spend + transaction count under the filter. */
export type TopSpendSupplier = TopSpendSuppliersQuery["topSpendSuppliers"]["results"][number];

/**
 * Top suppliers by spend, plus the distinct-supplier total. Powers the supplier
 * rankings table and the supplier chart's top-10 series.
 */
export function useTopSpendSuppliers(
  request: TopSpendSuppliersRequest,
  options?: UseQueryOptions<TopSpendSuppliersQuery, unknown, TopSpendSuppliersQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["topSpendSuppliers", request],
    topSpendSuppliersQuery,
    [{ request }],
    options,
  );

  return { data: data?.topSpendSuppliers, ...rest };
}
